import { render, staticRenderFns } from "./sdfbd.vue?vue&type=template&id=07461d99&scoped=true&"
import script from "./sdfbd.vue?vue&type=script&lang=js&"
export * from "./sdfbd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07461d99",
  null
  
)

export default component.exports